import React, { useState } from 'react';
import './ForgotPassword.css';

function ForgotPassword() {
    const [input, setInput] = useState('');
    const [error, setError] = useState('');

    // Validation function
    const validateInput = (value) => {
        if (!value) {
            return 'Email or phone number is required';
        }
        if (!/^\S+@\S+\.\S+$/.test(value) && !/^\d{10}$/.test(value)) {
            return 'Please enter a valid email or a 10-digit phone number';
        }
        return '';
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Run validation
        const validationError = validateInput(input);
        if (validationError) {
            setError(validationError);
        } else {
            setError('');
            alert('Reset instructions have been sent to your registered email or phone number.');
        }
    };

    const handleChange = (e) => {
        setInput(e.target.value);
        setError(''); // Clear error as user types
    };

    return (
        <div className='forgot-password'>
            <div className="d-flex align-items-center justify-content-center vh-100">
                <div className="card p-4" style={{ width: '400px' }}>
                    <h3 className="text-center">Forgot Password</h3>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="emailOrPhone" className="form-label">
                                Enter your registered email or phone number
                            </label>
                            <input
                                type="text"
                                className={`form-control ${error ? 'is-invalid' : ''}`}
                                id="emailOrPhone"
                                value={input}
                                onChange={handleChange}
                                placeholder="Email or Phone Number"
                            />
                            {error && <div className="invalid-feedback">{error}</div>}
                        </div>
                        <button type="submit" className="btn btn-primary w-100">
                            Submit
                        </button>
                    </form>
                </div>
            </div>

        </div>
    );
}

export default ForgotPassword;
